import { t } from '../domain/language/languageUtil'
import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { FixedContainer } from '../UI/index'
import { useBalance } from '../domain/balance/hook/useBalance'

interface BalanceProps {
  x: number
  y: number
  width: number
  height: number
  currencyStyle?: TextStyle
  titleStyle?: TextStyle
  amountStyle?: TextStyle
}

const defaultCurrencyStyle = new TextStyle({
  fontSize: 20,
  fill: '#9299A0',
  align: 'center',
})
const defaultTitleStyle = new TextStyle({
  fontSize: 30,
  fill: '#9299A0',
  align: 'center',
})
const defaultAmountStyle = new TextStyle({
  fontSize: 38,
  fill: '#FFFFFF',
  align: 'center',
})

/**
 * V1 版本，讀取 `useBalance()`（V1 toggle store 的 `FeatureToggleType.disableCurrencyDisplay`）。
 * 只有還在使用 Feature Toggle **V1** 的遊戲才應該使用這個元件——V2 遊戲的 V1 toggle store
 * 永遠不會被填值，用這個元件會導致幣別文字永遠顯示，不管後端把 V2 的 `displayCurrency` 設成什麼。
 * V2 遊戲請改用 {@link BalanceFeatureToggleV2}。
 */
export const Balance = (props: BalanceProps) => {
  const { balance, currency } = useBalance()

  const currencyStyle = props.currencyStyle ? props.currencyStyle : defaultCurrencyStyle
  const titleStyle = props.titleStyle ? props.titleStyle : defaultTitleStyle
  const amountStyle = props.amountStyle ? props.amountStyle : defaultAmountStyle

  return (
    <FixedContainer name="balance" x={props.x} y={props.y} width={props.width} height={props.height}>
      <Text name="currency" x={props.width / 2 - 140} anchor={0.5} y={props.height - 30} text={currency} style={currencyStyle} />
      <Text name="title" x={props.width / 2} anchor={0.5} y={30} text={t('main_control_panel_balance')} style={titleStyle} />
      <Text name="amount" x={props.width / 2 - 60} anchor={[0, 0.5]} y={props.height - 37} text={balance} style={amountStyle} />
    </FixedContainer>
  )
}
